import { render, staticRenderFns } from "./AscDetailsItem.vue?vue&type=template&id=85f71d08&scoped=true&"
import script from "./AscDetailsItem.vue?vue&type=script&lang=js&"
export * from "./AscDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./AscDetailsItem.vue?vue&type=style&index=0&id=85f71d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f71d08",
  null
  
)

export default component.exports